module.exports = __webpack_public_path__ + "img/shoucang.7833d892.png";